import {Button, Drawer, Space} from "antd";
import {useGetCustomerReview} from "../../../../../../../react-query-hooks/reviews/get-reviews";
import {SetSelectedCustomerStoreServiceOrderInfoPayload} from "../../../../../../../service-feature/useCases/get-orders/reducers/customer";
import {useGetCustomerStoreServicesOrdersContext} from "../../../../../../../service-feature/useCases/get-orders/context/customer";
import {CloseOutlined} from "@ant-design/icons";
import {ReviewForm} from "../../../../../../calls/past-calls/past-call-card/customer";
import {StyledStoreServiceOrderDrawer} from "../styles";

type CustomerStoreServiceOrderRevisionRequestDrawerProps = {
  orderDetails: SetSelectedCustomerStoreServiceOrderInfoPayload;
};

export function CustomerStoreServiceOrderLeaveAReviewDrawer({
  orderDetails,
}: CustomerStoreServiceOrderRevisionRequestDrawerProps) {
  const {
    state: {activeStoreServiceOrderDrawer},
    dispatch,
  } = useGetCustomerStoreServicesOrdersContext();
  const offeringId = orderDetails.productService.id;
  const offeringType = "product-service";
  const getCustomerReview = useGetCustomerReview({
    emailAddress: orderDetails.order.emailAddress,
    offering_id: offeringId,
    offering_type: offeringType,
  });

  const onDrawerClose = () => {
    dispatch({
      type: "set-active-store-service-order-drawer",
      payload: "order-info",
    });
  };
  return (
    <StyledStoreServiceOrderDrawer
      title={
        <>
          <p>
            {orderDetails.productService.name} / <span>Leave a review</span>
          </p>
        </>
      }
      placement="right"
      onClose={onDrawerClose}
      visible={activeStoreServiceOrderDrawer === "leave-a-review"}
      closable={false}
      extra={
        <Button size="small" type="text" onClick={onDrawerClose}>
          <CloseOutlined />
        </Button>
      }
    >
      <Space direction="vertical" style={{display: "flex"}} size={24}>
        <ReviewForm
          reviewData={getCustomerReview.data}
          offeringId={offeringId}
          offeringType={offeringType}
          closeReviewFormDrawer={onDrawerClose}
          // canEdit={getCustomerCanEditReview.data?.canEdit}
          customerFirstName={orderDetails.order.firstName}
          customerLastName={orderDetails.order.lastName}
          customerEmail={orderDetails.order.emailAddress}
        />
      </Space>
    </StyledStoreServiceOrderDrawer>
  );
}
